import { useWSMutation, WSMutationsConfig } from "@ws-react-query";
import type { planEnrollmentApiSpec } from "@wingspanhq/wingspan-api-types";
import { WSServiceError } from "../../utils/serviceHelper";
import { QUERY_BENEFITS_PLAN_ENROLLMENT } from "./useQueryPlanEnrollment";
import { QUERY_BENEFITS_PLAN_ENROLLMENTS } from "./useQueryPlanEnrollments";
import { cancelPlanEnrollment } from "../../services/api/planEnrollment/cancelPlanEnrollment";
import { QUERY_INSURANCE_COVERAGE } from "../insuranceCoverage/queries/useQueryInsuranceCoverage";
import { QUERY_INSURANCE_COVERAGES } from "../insuranceCoverage/queries/useQueryInsuranceCoverages";
import { QUERY_LIST_RESOURCE_EVENTS } from "../resourceEvents/queries/useQueryListEvents";

type IPlanEnrollment = planEnrollmentApiSpec.PlanEnrollment;

export const useMutationCancelPlanEnrollment = (
  config?: WSMutationsConfig<IPlanEnrollment, WSServiceError, string>
) =>
  useWSMutation<IPlanEnrollment, WSServiceError, string>(
    (planEnrollmentId: string) => cancelPlanEnrollment(planEnrollmentId),
    {
      dependencies: [
        QUERY_BENEFITS_PLAN_ENROLLMENT,
        QUERY_BENEFITS_PLAN_ENROLLMENTS,
        QUERY_INSURANCE_COVERAGE,
        QUERY_INSURANCE_COVERAGES,
        QUERY_LIST_RESOURCE_EVENTS
      ],
      ...config
    }
  );
